import StarsIcon from "@redotech/redo-icons/stars-01_filled.svg";
import { ConciergeProductFormSettings } from "@redotech/redo-model/concierge-product-form/concierge-product-form";
import { externallyAddConciergeCustomerMessage } from "@redotech/redo-web/concierge/utils";
import { Flex } from "@redotech/redo-web/flex";
import { FormEvent, memo, useEffect, useState } from "react";
import { ConciergeProductFormProps } from "./concierge-product-form";
import * as promptFormCss from "./prompt-form.module.css";
import { QuestionChipArea } from "./question-chip-area";

export const PromptForm = memo(function PromptForm({
  settings,
  storeName,
  useConciergeQuestions,
  onConciergeLoaded,
}: {
  settings: ConciergeProductFormSettings;
  storeName: string;
  useConciergeQuestions: ConciergeProductFormProps["useConciergeQuestions"];
  onConciergeLoaded: () => Promise<void>;
}) {
  const [question, setQuestion] = useState<string>("");

  useEffect(() => {
    void onConciergeLoaded();
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (event: FormEvent<HTMLDivElement>) => {
    event.preventDefault();
    externallyAddConciergeCustomerMessage(question);
    setQuestion("");
  };

  const handleQuestionSelect = (selectedQuestion: string) => {
    setQuestion(selectedQuestion);
  };

  return (
    <Flex as="form" dir="column" gap="lg" onSubmit={handleSubmit}>
      <Flex dir="row" gap="none">
        <Flex grow={1}>
          <label
            className={promptFormCss.label}
            htmlFor="prompt-form-input"
            style={{
              borderTopLeftRadius: settings.borderRadius,
              borderBottomLeftRadius: settings.borderRadius,
              fontSize: settings.fontSize,
            }}
          >
            <input
              className={promptFormCss.input}
              id="prompt-form-input"
              onChange={(e) => setQuestion(e.target.value)}
              placeholder={settings.placeholder.replace(
                "{storeName}",
                storeName,
              )}
              value={question}
            />
          </label>
        </Flex>
        <button
          className={promptFormCss.askButton}
          style={{
            borderTopRightRadius: settings.borderRadius,
            borderBottomRightRadius: settings.borderRadius,
            backgroundColor: settings.buttonBackgroundColor,
            color: settings.buttonTextColor,
            fontSize: settings.fontSize,
          }}
          type="submit"
        >
          <Flex align="center" gap="xs">
            <StarsIcon className={promptFormCss.icon} />
            {settings.buttonText}
          </Flex>
        </button>
      </Flex>
      <Flex dir="row" justify="flex-start">
        <QuestionChipArea
          onQuestionSelect={handleQuestionSelect}
          settings={settings}
          useConciergeQuestions={useConciergeQuestions}
        />
      </Flex>
    </Flex>
  );
});
